import { Button, Menu, MenuItem, MenuList } from "@material-ui/core";
import { ArrowDownward, ArrowUpward, SwapVert } from "@material-ui/icons";
import { memo, useState } from "react";
import { sortBy, sortDirections } from "../ContasReceberConstants";
import { useContasReceberService } from "../context/ContasReceberContext";
const SortMenuButton = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { filters, setSortBy, setSortDirection } = useContasReceberService();

  const [label, setLabel] = useState("Data");

  const handleOpenOptions = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectSort = ({ sortOption, sortLabel }) => {
    setSortBy(sortOption);
    setLabel(sortLabel);
    handleClose();
  };

  const swapSortDirection = () => {
    setSortDirection(
      filters.sortDirection === sortDirections.asc
        ? sortDirections.desc
        : sortDirections.asc
    );
  };

  const sortDirectionArrows = {
    asc: <ArrowUpward />,
    desc: <ArrowDownward />,
  };

  return (
    <>
      <Button
        size="small"
        startIcon={<SwapVert />}
        color="primary"
        variant="outlined"
        style={{
          borderRadius: "4px 0 0 4px",
          width: 200,
        }}
        onClick={handleOpenOptions}
      >
        {label}
      </Button>
      <Button
        size="small"
        color="primary"
        variant="outlined"
        onClick={() => swapSortDirection()}
        style={{
          borderRadius: "0 4px 4px 0",
          paddingRight: 0,
          paddingLeft: 0,
        }}
      >
        {sortDirectionArrows[filters.sortDirection]}
      </Button>
      <Menu
        anchorEl={anchorEl}
        onClose={handleClose}
        open={!!anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuList>
          {Object.entries(sortBy).map(([key, value]) => (
            <MenuItem
              value={value}
              key={value}
              onClick={() =>
                handleSelectSort({
                  sortLabel: key,
                  sortOption: value,
                })
              }
            >
              {key}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </>
  );
};

export default memo(SortMenuButton);
